import { render, staticRenderFns } from "./calendarExcTabItem.vue?vue&type=template&id=2ca77853"
import script from "./calendarExcTabItem.vue?vue&type=script&lang=js"
export * from "./calendarExcTabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports